import { Link as RouterLink } from 'react-router-dom';
import { Alert, Typography, Box, Stack, Button } from '@mui/material';
import Iconify from '../../../../components/Iconify';

export default function SuccessBlock({ block }) {
  const { title, message, details, action_url: actionUrl, action_label: actionLabel } = block;
  return (
    <Alert severity="success" icon={<Iconify icon="mdi:check-circle" />} sx={{ my: 1.5, borderRadius: 2 }}>
      <Typography variant="subtitle2" fontWeight={700}>{title}</Typography>
      {message && <Typography variant="body2">{message}</Typography>}
      {details && (
        <Box sx={{ mt: 1 }}>
          {Object.entries(details).map(([k, v]) => {
            if (!v && v !== 0) return null;
            const label = k.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
            return (
              <Stack key={k} direction="row" spacing={1}>
                <Typography variant="caption" color="text.secondary">{label}:</Typography>
                <Typography variant="caption">{String(v)}</Typography>
              </Stack>
            );
          })}
        </Box>
      )}
      {actionUrl && actionUrl.startsWith('/') && (
        <Button
          component={RouterLink}
          to={actionUrl}
          size="small"
          variant="contained"
          color="success"
          endIcon={<Iconify icon="mdi:arrow-right" />}
          sx={{ mt: 1.5 }}
        >
          {actionLabel || 'Open'}
        </Button>
      )}
    </Alert>
  );
}
